import React from 'react';
import StatsRow from '../Charts/StatsRow';

export default class UsersStatsRow extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false
		};
	}

	render() {
		// console.log('UsersStatsRow', this.props);

		return (
			<div className="UsersStatsRow">
				<div className="card">
					<div className="card-body">
						<StatsRow
							endpoint={this.props.users_stats_endpoint}
							// data={[
							// 	{ name: 'Total Users', value: 321 },
							// 	{ name: 'Active Users', value: 300 },
							// 	{ name: 'Inactive Users', value: 21 },
							// 	{ name: 'Pending Invites', value: 12 },
							// 	{ name: 'Login Pertentage', value: 46 }
							// ]}
						/>
					</div>
					{this.state.loading ? (
						<div className="loadingOverlay">
							<div className="spinner" />
						</div>
					) : null}
				</div>
			</div>
		);
	}
}
